module.exports = __webpack_public_path__ + "static/img/线上互动@2x (1).f4abd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/线上互动@2x (1).png
// module id = fDRC
// module chunks = 1